import { extend, localize } from 'vee-validate';
import ptBr from 'vee-validate/dist/locale/pt_BR.json';
import {
  required,
  regex,
  min,
  max,
} from 'vee-validate/dist/rules';

localize({
  pt_BR: ptBr,
});
localize('pt_BR');

extend('regex', regex);
extend('min', min);
extend('max', max);

extend('required', {
  ...required,
  message: 'Este campo é obrigatório',
});

extend('date', {
  validate(value) {
    return /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/.test(value);
  },
  message: 'A data deve estar no formato DD/MM/YYYY',
});

extend('cpf', {
  validate(value) {
    return /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(value);
  },
  message: 'O CPF deve ser válido',
});

extend('cnpj', {
  validate(value) {
    return /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(value);
  },
  message: 'O CNPJ deve ser válido',
});

extend('rg', {
  validate(value) {
    return /(?=.*\d)[A-Za-z0-9]{1,11}/.test(value);
  },
  message: 'O RG deve ser válido',
});

extend('cpfCnpj', {
  validate(value) {
    const isCpf = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(value);
    const isCnpj = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(value);

    return isCpf || isCnpj;
  },
  message: 'O CPF ou CNPJ deve ser válido',
});

extend('min_price', {
  validate(value) {
    return value >= 50;
  },
  message: 'Informe um valor igual ou maior que R$ 50',
});
